import React, { useState } from 'react';
import { FaChevronDown, FaClock, FaHome } from 'react-icons/fa';
import { FaBox } from 'react-icons/fa6';

function WeekendCourierService() {
    const [openFAQ, setOpenFAQ] = useState(null); // To track which FAQ is open

    const courierServices = [
      {
        service: "Same-Day Delivery",
        description: "Need to send a package urgently? Our same-day courier service ensures that your packages reach their destination as fast as possible.",
        icon: <FaClock className="w-16 h-16 text-black" />,
      },
      {
        service: "Weekend Pickup",
        description: "Our weekend pickup service ensures that your items are collected and delivered even on weekends. We offer flexible scheduling for your convenience.",
        icon: <FaHome className="w-16 h-16 text-black" />,
      },
      {
        service: "Package Tracking",
        description: "Track your parcels in real-time with our intuitive package tracking service. Stay informed about your deliveries 24/7.",
        icon: <FaBox className="w-16 h-16 text-black" />,
      },
    ];
  
    const handleFAQClick = (index) => {
      setOpenFAQ(openFAQ === index ? null : index); // Toggle open FAQ
    };
  
    return (
      <div>
        {/* Hero Section */}
        <div
          className="relative bg-cover bg-center h-[400px] md:h-[700px]"
          style={{ backgroundImage: "url('images/weekend.png')" }}
        >
          <div className="absolute inset-0 bg-black opacity-50"></div>
          <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
            <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Weekend Courier Services</h1>
          </div>
        </div>
  
        {/* Courier Services Section */}
        <section id="courier-services" className="py-16 px-3 bg-white text-black">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 justify-items-center">
            {courierServices.map((service, index) => (
              <div key={index} className="flex flex-col gap-6 items-center text-center mt-6">
                <h3 className="text-xl font-thin mb-1">{service.service}</h3>
                <div className="mb-2 text-red-500">{service.icon}</div>
                <p className="text-zinc-400 max-w-sm font-thin">{service.description}</p>
              </div>
            ))}
          </div>
        </section>
  
        {/* FAQ Section */}
        <section id="faq" className=" px-4 lg:p-20 bg-white text-black">
          <div className="flex justify-center">
            <div className="space-y-8 w-full max-w-5xl">
              <h2 className="text-3xl font-thin text-center mb-8">Weekend Courier FAQ's</h2>
              <div className="space-y-6">
                {['What if I need a delivery on Saturday or Sunday?', 
                  'Can I schedule a pickup for Sunday?', 
                  'Is package tracking available for weekend deliveries?', 
                  'How quickly can you pick up and deliver items on the weekend?'].map((question, index) => (
                  <div key={index}>
                    <div 
                      className="flex items-center justify-between cursor-pointer border-b border-zinc-700 pb-4"
                      onClick={() => handleFAQClick(index)}
                    >
                      <h3 className="text-xl font-thin">{question}</h3>
                      <FaChevronDown
                        className={`transition-transform ${openFAQ === index ? 'rotate-180' : ''} text-black`}
                      />
                    </div>
                    {openFAQ === index && (
                      <p className="text-zinc-400 mt-4">
                        {index === 0 && "Yes, we offer same-day delivery services on both Saturdays and Sundays to ensure your parcels are delivered even on the weekend."}
                        {index === 1 && "Absolutely! You can schedule a pickup for Sunday. Our team is available to collect your packages on the weekend."}
                        {index === 2 && "Yes, you can track your package throughout its journey, including weekend deliveries. Our tracking system is available 24/7."}
                        {index === 3 && "We guarantee quick pickups and deliveries on weekends. Depending on your location, we offer flexible times for both collection and delivery."}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

export default WeekendCourierService;
